var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('view-folders',{staticClass:"folders",attrs:{"views":_vm.views,"activeViewId":_vm.activeViewId},on:{"gotoPage":_vm.gotoPage}})}
var staticRenderFns = []

export { render, staticRenderFns }